module.exports = __webpack_public_path__ + "img/case-logo-21.495e8358.png";